import React from 'react';

const Services = () => {
  const services = [
    {
      title: "Permanent Staffing Solutions",
      description: "Comprehensive permanent staffing services connecting top talent with leading organizations across various industries.",
      features: [
        "Executive & Senior Level Recruitment",
        "Mid-Level Professional Placement",
        "Entry-Level Talent Acquisition",
        "Industry-Specific Expertise",
        "Background Verification Services",
        "Skills Assessment & Evaluation"
      ]
    },
    {
      title: "Temporary & Contract Staffing",
      description: "Flexible staffing solutions for short-term and contract positions to meet your immediate business needs.",
      features: [
        "Contract Staffing Services",
        "Temporary Workforce Solutions",
        "Project-Based Hiring",
        "Seasonal Staffing Support",
        "Interim Executive Placement",
        "Quick Turnaround Hiring"
      ]
    },
    {
      title: "Banking Services (Fino Bank)",
      description: "Comprehensive banking solutions through Fino Bank for individuals and businesses.",
      features: [
        "Savings & Current Accounts",
        "Loan Services (Personal, Business, Home)",
        "Digital Banking Solutions",
        "Payment & Remittance Services",
        "Investment & Insurance Products",
        "Financial Advisory Services"
      ]
    },
    {
      title: "HR Consulting Services",
      description: "Expert HR consulting to help organizations optimize their workforce and human resources management.",
      features: [
        "HR Strategy & Planning",
        "Talent Management Consulting",
        "Organizational Development",
        "Compensation & Benefits Design",
        "HR Process Optimization",
        "Change Management Support"
      ]
    },
    {
      title: "Skill Development & Training",
      description: "Training and skill development programs in collaboration with government and private organizations.",
      features: [
        "Workforce Training Programs",
        "Skill Enhancement Workshops",
        "Certification Programs",
        "Soft Skills Development",
        "Industry-Specific Training",
        "PMKVY & NSDC Certified Programs"
      ]
    },
    {
      title: "Payroll & Compliance Services",
      description: "Comprehensive payroll management and compliance services to ensure smooth HR operations.",
      features: [
        "Payroll Processing",
        "Statutory Compliance Management",
        "Tax Deduction & Filing",
        "Employee Benefits Administration",
        "Attendance & Leave Management",
        "HR Documentation & Reporting"
      ]
    }
  ];

  return (
    <section className="bg-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-black mb-4 text-center font-serif">Our Services</h1>
            <p className="text-lg text-gray-600 text-center mb-12 max-w-2xl mx-auto">
              Comprehensive staffing solutions and banking services tailored to your needs
            </p>
            <div className="grid md:grid-cols-2 gap-8">
              {services.map((service, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                  <h2 className="text-2xl font-bold text-black mb-3 font-serif">{service.title}</h2>
                  <p className="text-gray-700 mb-4">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <svg className="w-5 h-5 text-black mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-gray-600">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
  );
};

export default Services;
